module.exports = __webpack_public_path__ + "img/IMG_6351.cd09bd06.jpg";